export const GameStateTypes =  {
    PREVIEW: 'Preview',
    LIVE: 'Live',
    FINAL: 'Final'
};